.toggle {
  display: inline-flex;
  gap: 0.25rem;
  padding: 0.25rem;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  background: var(--bg-secondary, transparent);
}

.option {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.4rem 0.9rem;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.85rem;
  cursor: pointer;
}

.active {
  background: var(--text-primary);
  color: var(--bg-primary, #fff);
}

.save {
  font-size: 0.72rem;
  font-weight: 600;
  color: #16a34a;
}

.active .save {
  color: inherit;
}
